import { useState, useEffect } from 'react';

import { BasicRound, MultiAccurate } from '@lcsc-design/utils/decimal';
import Utils from '@lcsc-ui/utils/Utils';
import { InputNumber, Popover } from 'antd';

export default function DialogRight({ row, setParentValue, dialogRightProps }) {
  const [minNumberTipText, setMinNumberTipText] = useState(''); // tip相关
  const [isOpenMinNumberTips, setIsOpenMinNumberTips] = useState(false); // tip相关
  const [catInputNum, setCatInputNum] = useState(row?.ratio || 1); // 购买数量(初始值为最小起订量或1)
  const [wholeInputNum, setWholeInputNum] = useState(null); // 整包购买量
  const [totalMoney, setTotalMoney] = useState(null); // 总价
  const [minNum, setMinNumber] = useState(BasicRound(row?.productPriceList[0]?.productPrice || 0, 6)); // 单价
  const ratio = row?.ratio == 0 ? 1 : row?.ratio || 1;

  let productPriceList = row?.productPriceList || row?.productDiscountPriceList; // 价格表
  let selectNum = 1; // 选择数量

  useEffect(() => {
    getPrice();
  }, []);

  const amendNum = () => {
    const num = catInputNum * selectNum;
    if (num % ratio != 0) {
      setIsOpenMinNumberTips(true);
      setMinNumberTipText(`必须以${ratio}的倍数购买，已为您修正。`);
      setTimeout(() => setIsOpenMinNumberTips(false), 1000);
      setCatInputNum(Number(ratio) * Math.ceil(num / ratio));
      getPrice(Number(ratio) * Math.ceil(num / ratio));
    } else if (catInputNum < row?.minBuyNumber) {
      setIsOpenMinNumberTips(true);
      setCatInputNum(row?.minBuyNumber);
      getPrice(row?.minBuyNumber);
      setMinNumberTipText(`最小起订量为${row?.minBuyNumber}，已为您修正。`);
      setTimeout(() => setIsOpenMinNumberTips(false), 1000);
    }
  };
  const getPrice = (e) => {
    // 获取对应数量价格
    let price = minNum;
    if (productPriceList?.length > 0) {
      productPriceList?.forEach((v) => {
        if (
          Math.floor((e || catInputNum) / ratio) >= v.startPurchasedNumber &&
          (Math.floor((e || catInputNum) / ratio) <= v.endPurchasedNumber || v.endPurchasedNumber == -1)
        ) {
          price = v.productPrice;
        }
      });
    }
    setMinNumber(price); // 设置单价
    setTotalMoney(((e || catInputNum) * price).toFixed(2)); // 设置总价
  };
  const changeNumber = (e) => {
    setCatInputNum(e);
    getPrice(e);
    setParentValue(e);
    if (row?.productMinEncapsulationNumber === 1) {
      setWholeInputNum(e);
    }
  };

  const changeWholeNumber = (e) => {
    selectNum = e;
    setWholeInputNum(e);
    if (row?.productMinEncapsulationNumber) {
      setCatInputNum(e * row?.productMinEncapsulationNumber);
      getPrice(e * row?.productMinEncapsulationNumber);
      setParentValue(e * row?.productMinEncapsulationNumber);
    } else {
      getPrice(e);
    }
  };

  const blurNumber = (e) => {
    amendNum(e.target.value);
  };

  let priceTitle;
  let showDiscount;
  let showRebate;
  if (dialogRightProps) {
    const { activityType, rebate, discountPriceMaxDiscount } = dialogRightProps;
    showDiscount = ['discount', 'clearance', 'hot', 'mro_hot'].includes(activityType) && discountPriceMaxDiscount;
    showRebate = ['rebate', 'hot'].includes(activityType) && rebate && rebate !== '0'; // 爆款或者返利
    if (showRebate) {
      // 如果是返利，则直接取原价来遍历
      productPriceList = row?.originalPriceList;
    }
    priceTitle =
      showDiscount || showRebate ? (
        <>
          <section className="mx-auto flex justify-center items-center text-[12px] text-[#FF4960] w-[69px] h-[18px] bg-[rgba(255,73,96,0.1)] rounded-[8px] rounded-bl-none">
            <span>{showDiscount ? MultiAccurate(discountPriceMaxDiscount || 0, 10) + '折' : `返${rebate}%`}</span>
            <img
              className="ml-[6px] size-[13px]"
              src={`https://static.szlcsc.com/ecp/assets/newWeb/www/home/addCart/${showRebate ? 'rebate' : 'discount'}.svg`}
            />
          </section>
        </>
      ) : (
        '含增值税'
      );
  }

  // 现价
  const priceList = productPriceList?.map((item, index) => (
    <li key={index} className="h-[24px] leading-[24px] flex justify-center text-[12px]">
      <span className="flex-1 inline-block w-[52px] text-right text-[#000000]">
        {item?.startPurchasedNumber * ratio} +
      </span>
      <span className="flex-1 text-[#FF4960] text-left inline-block pl-[16px]">
        ￥{item?.productPrice || item.price}
      </span>
    </li>
  ));

  // 原价
  const originalPriceList = row?.originalPriceList.map((item, index) => (
    <li key={index} className="flex h-[24px] leading-[24px] justify-center text-[12px] text-[#BFBFBF] line-through">
      <span className="flex-1 text-left inline-block pl-[16px]">
        {(item?.productPrice || item.price) !==
          (productPriceList[index].productPrice || productPriceList[index].price) &&
          '￥' + (item?.productPrice || item.price)}
      </span>
    </li>
  ));

  return (
    <div className="flex-1">
      <div className="text-center mb-[16px]">
        <p className="mb-[16px] text- [#54657D]">{priceTitle}</p>
        <section className="flex justify-center items-center">
          {/* 现价 */}
          {!Utils.isEmpty(priceList) && <ul>{priceList}</ul>}
          {/* 原价 */}
          {!Utils.isEmpty(originalPriceList) && showDiscount && <ul>{originalPriceList}</ul>}
        </section>
      </div>
      <div className="mb-[16px] mt-[22px]">
        <span>
          购买数量：
          <Popover content={minNumberTipText} open={isOpenMinNumberTips} placement="topLeft">
            <InputNumber
              controls={false}
              size="mini"
              value={catInputNum}
              min={0}
              precision={0}
              className="w-[100px] mr-[10px]"
              onChange={changeNumber}
              onBlur={blurNumber}
              maxLength={8}
            />
            × <span className="text-[#FF4960]">￥{minNum} </span> ={' '}
            <span className="text-[#FF4960]">￥{totalMoney}</span>
          </Popover>
        </span>
      </div>
      {row?.productMinEncapsulationUnit && (
        <div>
          按整包装：
          <InputNumber
            controls={false}
            value={wholeInputNum}
            className="w-[100px]"
            onChange={changeWholeNumber}
            onBlur={blurNumber}
            maxLength={8}
          />
          <span className="ml-[5px] inline-block">{row?.productMinEncapsulationUnit}</span> (
          {`${row?.productMinEncapsulationNumber}${row?.productUnit}/${row?.productMinEncapsulationUnit}`})
        </div>
      )}
    </div>
  );
}
